module.exports = __webpack_public_path__ + "img/cg_ruoyi_jk.b7964ae4.jpg";